var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.41065 4.00562L2.80808 10.6156C2.77486 10.6489 2.75088 10.691 2.73945 10.7363L2.00762 13.6768C1.98573 13.7653 2.01172 13.8594 2.07625 13.924C2.12507 13.9729 2.1916 14 2.25966 14C2.2805 14 2.30182 13.9974 2.32257 13.9922L5.25999 13.2595C5.30577 13.248 5.34736 13.2241 5.38058 13.1909L11.9837 6.58138L9.41065 4.00562Z",
    fill: "#001A39"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6198 3.10436L12.8848 2.36862C12.3936 1.87689 11.5374 1.87736 11.0468 2.36862L10.1465 3.26986L12.7195 5.84553L13.6198 4.94429C13.8651 4.69876 14.0003 4.37195 14.0003 4.02438C14.0003 3.6768 13.8651 3.34999 13.6198 3.10436Z",
    fill: "#001A39"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.c177212eb991ec547182a78d7c5426ea.svg";
export { ForwardRef as ReactComponent };